<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">{{ typeTitle }}基本信息</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span>
              <strong> {{ typeTitle }}基本信息 </strong>
            </span>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="editMeeting('editMeetingForm')">
            保存
          </el-button>
        </div>
      </div>
      <div class="form_content">
        <el-row>
          <el-col
            :xs="{ span: 24, offset: 0 }"
            :sm="{ span: 24, offset: 0 }"
            :md="{ span: 18, offset: 0 }"
            :lg="{ span: 18, offset: 0 }"
            :xl="{ span: 18, offset: 0 }"
          >
            <el-form
              :model="editMeetingForm"
              :rules="editMeetingFormRules"
              ref="editMeetingForm"
              label-width="120px"
              class="demo-ruleForm"
              :label-position="is_xs ? 'top' : 'right'"
            >
              <el-form-item :label="typeTitle + '名称：'" prop="MeetingName">
                <el-input
                  ref="MeetingName"
                  v-model="editMeetingForm.MeetingName"
                  :disabled="editMeetingForm.State != 1 && !isSystemAdmin"
                ></el-input>
              </el-form-item>
              <el-form-item :label="typeTitle + '时间：'" required>
                <el-col :span="11">
                  <el-form-item class="el-form-item-internal" prop="StartTime">
                    <el-date-picker
                      ref="StartTime"
                      type="datetime"
                      placeholder="选择开始日期时间"
                      v-model="editMeetingForm.StartTime"
                      format="yyyy-MM-dd HH:mm"
                      default-time="9:00:00"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item class="el-form-item-internal" prop="EndTime">
                    <el-date-picker
                      ref="EndTime"
                      type="datetime"
                      placeholder="选择结束日期时间"
                      v-model="editMeetingForm.EndTime"
                      format="yyyy-MM-dd HH:mm"
                      default-time="18:00:00"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item
                label="联系人："
                prop="ContactPeople"
                v-if="editMeetingForm.MeetingType === 1"
              >
                <el-input
                  ref="ContactPeople"
                  v-model="editMeetingForm.ContactPeople"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系电话："
                prop="ContactPhone"
                v-if="editMeetingForm.MeetingType === 1"
              >
                <el-input
                  ref="ContactPhone"
                  v-model="editMeetingForm.ContactPhone"
                ></el-input>
              </el-form-item>
              <el-form-item :label="typeTitle + '地址：'" prop="Address">
                <el-input
                  ref="Address"
                  v-model="editMeetingForm.Address"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="会议类型：">
                <el-select
                  v-model="editMeetingForm.MeetingType"
                  placeholder="请选择会议类型"
                >
                  <el-option
                    v-for="meetingType in meetingTypes"
                    :key="meetingType.DictionaryID"
                    :label="meetingType.DictionaryName"
                    :value="meetingType.DictionaryID"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="创建人：" prop="CreateUserName">
                <span>{{ editMeetingForm.CreateUserName }}</span>
              </el-form-item>
              <el-form-item label="是否匿名：">
                <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                  <el-form-item class="el-form-item-internal" prop="Verify">
                    <el-switch
                      v-model="editMeetingForm.Verify"
                      @change="meetingVerifyChange()"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="报名签到：">
                <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                  <el-form-item
                    class="el-form-item-internal"
                    prop="IsVoteUserApply"
                  >
                    <el-switch v-model="editMeetingForm.IsVoteUserApply">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <el-form-item class="el-form-item-internal" prop="IsGoApply">
                    <el-checkbox
                      v-model="editMeetingForm.IsGoApply"
                      :disabled="!editMeetingForm.IsVoteUserApply"
                    >
                      扫码是否首先进入报名签到页面
                    </el-checkbox>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="报名签到文本：" prop="ApplyButtonText">
                <el-input
                  ref="ApplyButtonText"
                  v-model="editMeetingForm.ApplyButtonText"
                  :disabled="!editMeetingForm.IsVoteUserApply"
                ></el-input>
              </el-form-item>
              <el-form-item label="报名截止时间：" prop="ApplyDeadlineTime">
                <el-date-picker
                  type="datetime"
                  placeholder="选择截止日期时间"
                  v-model="editMeetingForm.ApplyDeadlineTime"
                  format="yyyy-MM-dd HH:mm"
                  default-time="9:00:00"
                  style="width: 100%"
                  :disabled="!editMeetingForm.IsVoteUserApply"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="提示信息标题：" prop="TipsTitle">
                <el-input
                  ref="TipsTitle"
                  v-model="editMeetingForm.TipsTitle"
                ></el-input>
              </el-form-item>
              <el-form-item label="提示信息内容：" prop="TipsContent">
                <!-- <quill-editor
                  v-model="editMeetingForm.TipsContent"
                  ref="contentQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)"
                  @ready="onEditorReady($event)"
                >
                </quill-editor> -->
                <VueUeditorWrap
                  ref="TipsContent"
                  v-model="editMeetingForm.TipsContent"
                  :config="ueditorConfig"
                ></VueUeditorWrap>
              </el-form-item>
              <el-form-item :label="typeTitle + '简介：'" prop="Contents">
                <el-input
                  ref="Contents"
                  type="textarea"
                  v-model="editMeetingForm.Contents"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="editMeeting('editMeetingForm')"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ueditorConfig from '../../../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'Home',
  components: {
    // quillEditor,
    VueUeditorWrap
  },
  data () {
    const phoneReg = /(^(\d{2,4}[-_－—]?)?\d{3,8}([-_－—]?\d{3,8})?([-_－—]?\d{1,7})?$)|(^0?1[35]\d{9}$)/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('电话号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      meetingTypes: [],
      editMeetingForm: {
        MeetingName: '',
        StartTime: '',
        EndTime: '',
        MeetingType: null,
        Address: '',
        Contents: '',
        IsVoteUserApply: false,
        ApplyDeadlineTime: '',
        IsGoApply: false,
        ApplyButtonText: '',
        TipsTitle: '',
        TipsContent: '',
        IsEveryDay: false,
        IsAllowTrack: false,
        ContactPeople: '',
        ContactPhone: ''
      },
      editMeetingFormRules: {
        MeetingName: [
          { required: true, message: '请输入会议名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }],
        StartTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        EndTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        MeetingType: [
          { required: true, message: '请选择会议类型', trigger: 'change' }
        ],
        Address: [
          { max: 500, message: '长度在 500 个字符以内', trigger: 'blur' }
        ],
        Contents: [
          { max: 4000, message: '长度在 4000 个字符以内', trigger: 'blur' }
        ],
        ApplyButtonText: [
          { max: 20, message: '长度在 20 个字符以内', trigger: 'blur' }
        ],
        TipsTitle: [
          { max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ],
        ContactPeople: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 200 个字符', trigger: 'blur' }],
        ContactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 30 个字符', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }]
      },
      isSystemAdmin: false,
      //   editorOption: {
      //     theme: 'snow',
      //     placeholder: '请输入...',
      //     modules: {
      //       // 工具栏设置
      //       toolbar: {
      //         container: [
      //           ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
      //           // ['blockquote', 'code-block'], // 引用，代码块
      //           // [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
      //           [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
      //           [{ script: 'sub' }, { script: 'super' }], // 上下标
      //           [{ indent: '-1' }, { indent: '+1' }], // 缩进
      //           [{ align: [] }], // 对齐方式
      //           [{ direction: 'rtl' }], // 文本方向
      //           [{ size: ['12px', '14px', '16px', '20px', '24px', '36px'] }], // 字体大小
      //           [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
      //           [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
      //           [{ font: ['sans serif', 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体
      //           ['link', 'image', 'video'], // 上传图片、上传视频
      //           ['clean'] // 清除字体样式
      //         ],
      //         handlers: {
      //         }
      //       }
      //     }
      //   },
      typeTitle: '',
      ueditorConfig: ueditorConfig
    }
  },
  inject: ['getMeetingVoteInfo'],
  methods: {
    meetingVerifyChange: function () {
      const _this = this
      if (_this.editMeetingForm.Verify) {
        _this.editMeetingForm.IsEveryDay = true
      } else {
        _this.editMeetingForm.IsEveryDay = false
      }
    },
    getMeetingTypes: function () {
      this.openLoading()
      this.$api.dictionary.getDictionarys({
        parent: 1
      })
        .then(data => {
          this.meetingTypes = data
          this.getMeetingVote()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
    },
    getMeetingVote: function () {
      const _this = this
      _this.$api.meetingManage.getMeetingVote({
        meetingID: _this.$route.params.mid
      })
        .then(data => {
          _this.editMeetingForm = data
          if (_this.editMeetingForm.MeetingType === 1) {
            _this.typeTitle = '活动'
          } else {
            _this.typeTitle = '会议'
          }
          if (!_this.editMeetingForm.ApplyDeadlineTime) {
            _this.editMeetingForm.ApplyDeadlineTime = new Date(this.$moment(new Date()).format('yyyy-MM-DD ') + '18:00')
          }
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
    },
    editMeeting: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid, object) => {
        if (valid) {
          _this.openLoading()
          //   if (_this.editMeetingForm.TipsContent) {
          //     if (_this.editMeetingForm.TipsContent.indexOf('ql-indent-1') !== -1) {
          //       _this.editMeetingForm.TipsContent = _this.editMeetingForm.TipsContent + '<style lang="less">.ql-indent-1{padding-left:2em;}</style>'
          //     }
          //     if (_this.editMeetingForm.TipsContent.indexOf('ql-indent-2') !== -1) {
          //       _this.editMeetingForm.TipsContent = _this.editMeetingForm.TipsContent + '<style lang="less">.ql-indent-2{padding-left:4em;}</style>'
          //     }
          //     if (_this.editMeetingForm.TipsContent.indexOf('ql-indent-3') !== -1) {
          //       _this.editMeetingForm.TipsContent = _this.editMeetingForm.TipsContent + '<style lang="less">.ql-indent-3{padding-left:6em;}</style>'
          //     }
          //     if (_this.editMeetingForm.TipsContent.indexOf('ql-indent-4') !== -1) {
          //       _this.editMeetingForm.TipsContent = _this.editMeetingForm.TipsContent + '<style lang="less">.ql-indent-4{padding-left:8em;}</style>'
          //     }
          //     if (_this.editMeetingForm.TipsContent.indexOf('ql-indent-5') !== -1) {
          //       _this.editMeetingForm.TipsContent = _this.editMeetingForm.TipsContent + '<style lang="less">.ql-indent-5{padding-left:10em;}</style>'
          //     }
          //   }
          _this.$api.meetingManage.editMeeting({
            MeetingId: _this.editMeetingForm.MeetingId,
            MeetingName: _this.editMeetingForm.MeetingName,
            StartTime: _this.$moment(_this.editMeetingForm.StartTime).format('YYYY-MM-DD HH:mm'),
            EndTime: _this.$moment(_this.editMeetingForm.EndTime).format('YYYY-MM-DD HH:mm'),
            MeetingType: _this.editMeetingForm.MeetingType,
            Address: _this.editMeetingForm.Address,
            Contents: _this.editMeetingForm.Contents,
            Verify: _this.editMeetingForm.Verify,
            IsVoteUserApply: _this.editMeetingForm.IsVoteUserApply,
            ApplyDeadlineTime: _this.$moment(_this.editMeetingForm.ApplyDeadlineTime).format('YYYY-MM-DD HH:mm'),
            IsGoApply: _this.editMeetingForm.IsGoApply,
            ApplyButtonText: _this.editMeetingForm.ApplyButtonText,
            TipsTitle: _this.editMeetingForm.TipsTitle,
            TipsContent: _this.editMeetingForm.TipsContent,
            IsEveryDay: _this.editMeetingForm.IsEveryDay,
            IsAllowTrack: _this.editMeetingForm.IsAllowTrack,
            ContactPeople: this.editMeetingForm.ContactPeople,
            ContactPhone: this.editMeetingForm.ContactPhone
          }).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '修改成功!',
              customClass: 'custom_message'
            })
            _this.getMeetingVoteInfo()
            _this.openLoading().close()
          }).catch(err => {
            _this.openLoading().close()
            return err
          })
        } else {
          for (const i in object) {
            let dom = this.$refs[i]
            if (Object.prototype.toString.call(dom) !== '[object Object]') {
              dom = dom[0]
            }
            dom.$el.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            })
            break
          }
          return false
        }
      })
    },
    getIsCompanySystem () {
      this.$api.role.getIsCompanySystem().then(data => {
        this.isSystemAdmin = data.IsSystemAdmin
      }).catch(err => {
        return err
      })
    }
    // // 准备编辑器
    // onEditorReady (editor) {
    //   addQuillTitle()
    // },
    // // 失去焦点事件
    // onEditorBlur () { },
    // // 获得焦点事件
    // onEditorFocus (val, editor) {
    //   // window.console.log(val) // 富文本获得焦点时的内容
    //   // editor.enable(false) // 在获取焦点的时候禁用
    // },
    // // 内容改变事件
    // onEditorChange () { }
  },
  mounted () {
    // const fontSizeStyle = Quill.import('attributors/style/size')
    // fontSizeStyle.whitelist = ['12px', '14px', '16px', '20px', '24px', '36px']
    // Quill.register(fontSizeStyle, true)

    // const alignStyle = Quill.import('attributors/style/align')
    // alignStyle.whitelist = ['right', 'center', 'justify']
    // Quill.register(alignStyle, true)

    // const fontStyle = Quill.import('attributors/style/font')
    // fontStyle.whitelist = ['sans serif', 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
    // Quill.register(fontStyle, true)

    // const directionStyle = Quill.import('attributors/style/direction')
    // Quill.register(directionStyle, true)
  },
  created () {
    this.editMeetingForm.MeetingId = this.$route.params.mid
    this.getMeetingTypes()
    this.getIsCompanySystem()
  }
}
</script>
<style lang="less">
.el-picker-panel {
  z-index: 9002 !important;
}
// .quill-editor {
//   height: 150px;
// }
// .quill-editor .ql-container {
//   min-height: 170px;
// }
// /*
// 这里一定要写上，是用来把相关改变的配置在工具栏正常显示
// 如果不写，字体样式的下拉会重复显示Sans Serif，字体大小的下拉会重复显示Normal
// */
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='SimSun']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='SimSun']::before {
//   content: '宋体';
//   font-family: 'SimSun' !important;
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='SimHei']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='SimHei']::before {
//   content: '黑体';
//   font-family: 'SimHei';
// }
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-label[data-value='Microsoft-YaHei']::before,
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-item[data-value='Microsoft-YaHei']::before {
//   content: '微软雅黑';
//   font-family: 'Microsoft YaHei';
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='KaiTi']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='KaiTi']::before {
//   content: '楷体';
//   font-family: 'KaiTi' !important;
// }
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-label[data-value='FangSong']::before,
// .quill-editor
//   .ql-picker.ql-font
//   .ql-picker-item[data-value='FangSong']::before {
//   content: '仿宋';
//   font-family: 'FangSong';
// }
// .quill-editor .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
// .quill-editor .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
//   content: 'Arial';
//   font-family: 'Arial';
// }

// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='12px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='12px']::before {
//   content: '12px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='14px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='14px']::before {
//   content: '14px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='16px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='16px']::before {
//   content: '16px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='20px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='20px']::before {
//   content: '20px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='24px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='24px']::before {
//   content: '24px';
// }
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-label[data-value='36px']::before,
// .quill-editor
//   .ql-snow
//   .ql-picker.ql-size
//   .ql-picker-item[data-value='36px']::before {
//   content: '36px';
// }
// .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
//   padding-left: 2em;
// }
// .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
//   padding-left: 4em;
// }
// .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
//   padding-left: 6em;
// }
// .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
//   padding-left: 8em;
// }
// .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
//   padding-left: 10em;
// }
</style>
